export enum SourceShareEnum {
  SourceShareFunnel = 'share_funnel',
  SourceShareCampaign = 'share_campaign',
  SourceShareBlog = 'share_blog',
  SourceShareNewsletter = 'share_newsletter',
  SourceShareMembershipCourse = 'share_membership_course',
  SourceShareUserBlock = 'share_user_block',
  SourceShareMasterBlock = 'share_master_block',
}

export const sourceShareLocoKeys: Record<SourceShareEnum, string> = {
  [SourceShareEnum.SourceShareFunnel]: 'dashboard.affiliate.source_share_funnel',
  [SourceShareEnum.SourceShareCampaign]: 'dashboard.affiliate.source_share_campaign',
  [SourceShareEnum.SourceShareBlog]: 'dashboard.affiliate.source_share_blog',
  [SourceShareEnum.SourceShareNewsletter]: 'dashboard.affiliate.source_share_newsletter',
  [SourceShareEnum.SourceShareMembershipCourse]:
    'dashboard.affiliate.source_share_membership_course',
  [SourceShareEnum.SourceShareUserBlock]: 'dashboard.affiliate.source_share_user_block',
  [SourceShareEnum.SourceShareMasterBlock]: 'dashboard.affiliate.source_share_master_block',
}
